import React from 'react'
import PropTypes from 'prop-types'
import { SocketIO } from '../../core'
import SocketIOClient from 'socket.io-client'

export const IOSocketContext = React.createContext('socket')

/**
 * SocketIO Provider for react component
 *
 * @date 2022-10-05
 * @export
 * @class SIOSocket
 * @extends {React.Component}
 */
export class SIOSocket extends React.Component {
  static propTypes = {
    options: PropTypes.object,
    children: PropTypes.element.isRequired,
  }

  /**
   *
   * Socket Handle
   *
   * @type {SocketIOClient.Socket}
   *
   */
  socket

  /**
   * Creates an instance of SIOSocket.
   * @date 2022-10-05
   * @param {*} props
   */
  constructor(props) {
    super(props)

    const default_options = {
      uri: '/socketio',
      token: '',
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 10000,
      autoConnect: true,
      transports: ['websocket', 'polling'],
      rejectUnauthorized: true,
    }

    const options = { ...default_options, ...props.options }

    this.socket = SocketIOClient(options.uri, options)

    SocketIO.setHandler(this.socket)
    this.socket.status = 'initialized'

    for (let status in [
      'connect',
      'disconnect',
      'error',
      'reconnect',
      'reconnect_attempt',
      'reconnecting',
      'reconnect_failed',
    ]) {
      this.socket.on(status, error => {
        this.socket.status = status
        console.debug(status, error || '')
      })
    }
  }

  componentWillUnmount() {
    this.socket.removeAllListeners()
    this.socket.offAny()
    this.socket.disconnect()
  }

  render() {
    return (
      <>
        <IOSocketContext.Provider value={this.socket}>
          {this.props.children}
        </IOSocketContext.Provider>
      </>
    )
  }
}
